<script>

import {discountServiceList, getAvailableServiceList} from "@/api/subscriptions";

import * as organizationApi from '@/api/organizations';
import SubscriptionServiceItem from "@/app/components/subscriptions/components/SubscriptionServiceItem.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'SubscriptionPage',
  components: {SubscriptionServiceItem},
  data() {

    this.setStep(0)

    let services = []

    let selected_services = []

    let discounts = []

    discountServiceList().then(
        (json) => {
          this.discounts = json.data.data.periods
          this.setDiscounts(json.data.data.periods)
        }
    )

    getAvailableServiceList().then(
        (json) => {
          this.services = json.data.data.services
        }
    )

    return {
      services: services,
      selected_services: selected_services,
      durations: [],
      organizations: [],
      query: '',
      discounts: discounts,
    }
  },

  mounted() {
    this.load();
  },

  computed: {
    serviceList() {
      return this.services
    },
    orgList() {
      return this.organizations.filter(
          (item) => {
            return item.name.toLowerCase().includes(this.query.toLowerCase()) ||
                item.inn.toLowerCase().includes(this.query.toLowerCase())
          }
      )
    },
    ...mapGetters('subscription', [
      'isChecked',
      'isModalVisible',
      'getBusySlots',
      'getSlots',
      'getItemSlots',
      'getItems',
      'isSlotPresented',
      'getStep'
    ]),
    ...mapGetters('user', ['USER_ID']),
    ...mapGetters('workspace', ['ID_WORK_SPACE']),
    serviceNum() {
      return this.services.filter(service => this.isChecked(service.id)).length;
    },
    slotsNum() {
      let acc = 0
      if (this.services.length) {
        this.services.map(
            service => {
              if (this.isChecked(service.id)) {
                acc = acc + this.getSlots(service.id)
              }
            }
        )
      }
      return acc
    },
    selectedSlotsNum() {
      let acc = 0
      if (this.services.length) {
        this.services.map(
            service => {
              acc = acc + this.getItems(service.id).length
            })
      }
      return acc
    },
    readyToNextStep() {
      return this.serviceNum;
      // && this.slotsNum === this.selectedSlotsNum
    }
  }
  ,
  methods: {
    showOrgList(service_id) {
      this.showModal(service_id)
      this.$refs.orgListDialog.showModal();
    },
    hideOrgList() {
      this.hideModal()
      this.$refs.orgListDialog.close()
    },
    ...
        mapActions('subscription', ['setStep', 'setSlots', 'hideModal', 'showModal', 'toggleItemSlot', 'setDiscounts']),
    async load() {
      let response = await organizationApi.workspaceOrganizations(this.ID_WORK_SPACE);
      this.organizations = response.data.data.map(
          (item) => {
            return {
              id: item.id,
              name: item.short_name,
              inn: item.inn
            }
          }
      )
    }
  }
}
</script>

<template>
  <div class="ais24--subscription">
    <div class="ais24--container">
      <div class="ais24--steps">
        <ul class="ais24--steps__list">
          <li class="ais24--steps__item" :class="getStep() === 0 ? ' active': ''">Подписка на сервисы</li>
          <li class="ais24--steps__item" :class="getStep() === 1 ? ' active': ''">Детали подписки</li>
          <li class="ais24--steps__item" :class="getStep() === 2 ? ' active': ''">Оплата</li>
        </ul>
      </div>
      <header class="ais24--header">
        <h2 class="ais24--title">Подписка на сервисы</h2>
      </header>
      <div class="ais24--services">
        <ul class="ais24--services__list">
          <SubscriptionServiceItem v-for="service in serviceList" v-bind:key="service.id" :service="service"
                                   @showDialogModal="showOrgList"
          />
        </ul>
      </div>
      <div class="ais24--actions-bar">
        <div class="ais24--container">
          <div class="ais24--actions-bar-holder">
            <div class="ais24--actions-bar-holder__previous">
              <router-link :to="{name: 'main_page'}" class="ais24--button ais24--button--outline ais24--button--large">
                <span class="ais24--button__text">Назад</span>
              </router-link>
            </div>
            <div class="ais24--actions-bar-holder__status">Выбран
              <mark>{{ serviceNum }} сервис</mark>
            </div>
            <div class="ais24--actions-bar-holder__next">
              <router-link class="ais24--button ais24--button--primary ais24--button--large"
                           :to="{name: 'SubscriptionDetailsPage'}" :disabled="!readyToNextStep">
                <span class="ais24--button__text">Продолжить</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <dialog class="ais24--dialog ais24--dialog--medium" id="addOrganizations" data-type="popup" ref="orgListDialog">
      <button class="ais24--dialog-close" type="button" @click="hideOrgList">
        <svg class="ais24--icon ais24--icon--32x32">
          <use xlink:href="/img/sprite.svg#icon-32-cross-circle"></use>
        </svg>
      </button>
      <header class="ais24--dialog-header">
        <div class="ais24--dialog-header__headline">
          <h3 class="ais24--dialog-header__title">Добавить организации</h3>
          <div class="ais24--dialog-header__caption">Выберите организации из списка и добавьте их к сервису</div>
        </div>
        <div class="ais24--dialog-header__content">
          <fieldset class="ais24--fieldset">
            <div class="ais24--field-search">
              <input class="ais24--field-search__input" type="search" placeholder="Поиск по организациям или ИНН"
                     v-model="query">
            </div>
          </fieldset>
        </div>
      </header>
      <div class="ais24--dialog-body">
        <div class="ais24--organizations-choice">
          <ul class="ais24--organizations-choice__list">
            <li class="ais24--organizations-choice__item" v-for="org in orgList" v-bind:key="org.id">
              <div class="ais24--field-checkbox ais24--field-checkbox--bordered">
                <label class="ais24--field-checkbox__label">
                  <input class="ais24--field-checkbox__input" type="checkbox"
                         :checked="isSlotPresented(org)" @click="toggleItemSlot({slot: org, service_id: 0})">
                  <span class="ais24--field-checkbox__title">
                    <span class="ais24--field-checkbox__caption">{{ org.name }}</span><br/>
                    <span class="ais24--field-checkbox__text">ИНН {{ org.inn }}</span>
                  </span>
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <footer class="ais24--dialog-footer">
        <div class="ais24--organizations-choice-action">
          <div class="ais24--organizations-choice-action__status">Занято мест
            <mark>{{ getItemSlots.length }} из {{ getSlots(0) }}</mark>
          </div>
          <button class="ais24--button ais24--button--primary ais24--button--large" type="button"
                  @click="hideOrgList">
            <span class="ais24--button__text">Продолжить</span>
          </button>
        </div>
      </footer>
    </dialog>

  </div>

</template>

<style scoped lang="scss">
.ais24--dialog .ais24--dialog-body {
  flex: auto;
}
</style>
